import { useState } from 'react';
import { useVehicleImageUrl } from '@/hooks/useVehicleImage';
import unknownVehicle from '@/assets/unknown-vehicle.svg';

const SIZE_CLASSES = {
  sm: 'w-[80px] h-[53px]',
  md: 'w-[140px] h-[93px]',
  lg: 'w-[220px] h-[147px]',
} as const;

interface VehicleImageProps {
  vin: string | null | undefined;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function VehicleImage({ vin, size = 'md', className = '' }: VehicleImageProps) {
  const imageUrl = useVehicleImageUrl(vin);
  const [errored, setErrored] = useState(false);

  const sizeClass = SIZE_CLASSES[size];
  const baseClass = `${sizeClass} rounded-lg object-contain bg-[#1a1a2e] border border-gray-700/50 flex-shrink-0 ${className}`;

  if (!imageUrl || errored) {
    return <img src={unknownVehicle} alt="Unknown vehicle" className={baseClass} />;
  }

  return (
    <img
      src={imageUrl}
      alt="Vehicle"
      className={baseClass}
      onError={() => setErrored(true)}
    />
  );
}
